/**
 * Component: M57 Company Positions
 * 
 */
'use strict';

export class CompanyPositions 
{
  constructor()
  {
    this.selectors = {
      component: $('.c-v4-m57-company-positions'),
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_dropdowns();
  }

  init_dropdowns() {
    document.addEventListener('click', e => {
      const dropdown = e.target.matches('[data-company-position-dropdown]');
      if (!dropdown && e.target.closest('[data-company-position-dropdown]') != null) return;

      let currentDrop;
      if (dropdown) {
        currentDrop = e.target.closest('[data-company-position-dropdown]');

        if (dropdown === currentDrop) {
          currentDrop.classList.toggle('active');
        }
        else {
          currentDrop.classList.toggle('active');
        }
      }

    });

  }

}
